import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import z from 'zod'
export const useMobileMediaQuery = () => {
  const [onMobile, updateMobileQuery] = useState(false)
  const mql = window.matchMedia('(max-width:640px)')

  useEffect(() => {
    if (mql.matches) {
      updateMobileQuery(true)
    }
    mql.onchange = (event) => {
      if (event.matches) {
        updateMobileQuery(true)
      } else {
        updateMobileQuery(false)
      }
    }
    return () => {
      mql.onchange = null
    }
  }, [])

  return onMobile
}

export const usePagination = <T>(list: Array<T>, itemsPerPage: number) => {
  const [currentPage, setCurrentPage] = useState(1)
  const getCurrentPageData = useCallback((): T[] => {
    const startIndex = (currentPage - 1) * itemsPerPage
    return list.slice(startIndex, startIndex + itemsPerPage)
  }, [currentPage])
  return { currentPage, setCurrentPage, getCurrentPageData }
}

// type DelayedQueryOptions<TQueryFnData, TError> = Omit<
//   UseQueryOptions<TQueryFnData, TError>,
//   'queryFn' | 'queryKey'
// > & {
//   queryFn: QueryFunction<TQueryFnData>
//   queryKey: QueryKey
// }
//
// export function useDelayedQuery<
//   TQueryFnData = unknown,
//   TError = unknown,
//   TData = TQueryFnData,
// >(options: DelayedQueryOptions<TQueryFnData, TError>, delay = 2000) {
//   const queryResult = useQuery(options)
//   const [renderLoadingUI, setIsLoading] = useState(false)
//   useEffect(() => {
//     if (queryResult.fetchStatus === 'fetching') {
//       setIsLoading(true)
//     } else {
//       setTimeout(() => {
//         setIsLoading(false)
//       }, delay)
//     }
//   }, [queryResult.isFetching])
//   return { ...queryResult, renderLoadingUI }
// }

export const useArtificialDelay = (isFetching: boolean, delay = 800) => {
  const [renderLoadingUI, setIsLoading] = useState(false)
  useEffect(() => {
    if (isFetching) {
      setIsLoading(true)
    } else {
      setTimeout(() => {
        setIsLoading(false)
      }, delay)
    }
  }, [isFetching])
  return renderLoadingUI
}

export function useValidatedParams<T extends z.ZodSchema>(
  schema: T
): z.infer<T> {
  const params = useParams()
  const result = schema.safeParse(params)

  if (!result.success) {
    throw new Error('URL parameters validation failed')
  }

  return result.data
}
